var exports = {
  "ri": "PollAnswerVotersModal.module__smallText___Nk1XWl",
  "ks": "PollAnswerVotersModal.module__contentSplit___Nk1XWl",
  "T8": "PollAnswerVotersModal.module__answerList___Nk1XWl",
  "ZF": "PollAnswerVotersModal.module__answer___Nk1XWl",
  "yy": "PollAnswerVotersModal.module__answerText___Nk1XWl",
  "CE": "PollAnswerVotersModal.module__scrollerPadding___Nk1XWl",
  "gT": "PollAnswerVotersModal.module__scrollerContent___Nk1XWl",
  "Pb": "PollAnswerVotersModal.module__scrollerVoid___Nk1XWl",
  "hQ": "PollAnswerVotersModal.module__voterList___Nk1XWl",
  "Vq": "PollAnswerVotersModal.module__voter___Nk1XWl",
};

module.exports = exports;
